import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineTachometerFastIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m15.29 10.29-2.78 2.78A2.0872 2.0872 0 0 0 12 13a2 2 0 0 0-2 2c.0022.1722.0257.3435.07.51l-.78.78a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9989.9989 0 0 0 .71-.2958l.78-.78c.1664.0443.3377.0678.51.07a2 2 0 0 0 2-2 2.0969 2.0969 0 0 0-.07-.51l2.78-2.78a1.0041 1.0041 0 1 0-1.42-1.42ZM12 4a10.0004 10.0004 0 0 0-7.0711 2.929A10 10 0 0 0 1.9999 14a9.91 9.91 0 0 0 1.69 5.56 1.0015 1.0015 0 0 0 1.8129-.3691A1.0012 1.0012 0 0 0 5.35 18.44 8.0003 8.0003 0 0 1 7.8865 7.1314 8 8 0 0 1 18.65 18.44a.9997.9997 0 0 0 .83 1.56 1 1 0 0 0 .83-.44A9.9107 9.9107 0 0 0 22 14 9.9999 9.9999 0 0 0 12 4Z"/>
  </SvgIcon>
}

export default LineTachometerFastIcon
